var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{class:{ 'mt-4 mb-5': !_vm.margin_none }},[_c('b-colxx',{attrs:{"sm":"12","md":"12","lg":"12"}},[_c('h3',{staticClass:"line-title text-muted"},[_c('span',{style:({ backgroundColor: _vm.backgroundColor })},[_vm._v(_vm._s(_vm.title))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }